import type {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    Pagination,
    type SxProps,
    Tooltip,
    Typography
} from "@mui/material";
import {useGeneral} from "@contexts/GeneralContext.tsx";
import {Autorenew} from "@mui/icons-material";
import {Dispatch, SetStateAction} from "react";

export interface DefaultPaginationProps {
    pagination: IPagination,
    setPagination: Dispatch<SetStateAction<IPagination>>,
    loading?: boolean
    sx?: SxProps
    posicao?: 'top' | 'bottom'
}

/**
 * Componente de paginação padrão, só jogar dentro de uma grid que consuma todo o espaço disponivel
 * @constructor
 */
export function DefaultPagination(props: DefaultPaginationProps) {
    const {
        pagination,
        setPagination,
        sx,
        posicao
    } = props;
    const {adjustSizeLevel} = useGeneral()

    const loading = pagination.loading || props.loading;

    const rollAnimation = {
        // 2. Usar o nome único na definição do @keyframes
        [`@keyframes roll`]: {
            '0%': {
                transform: "rotate(0deg)"
            },
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
    };

    return (
        <Grid>
            {posicao == 'bottom' && <Divider/>}
            <Grid container justifyContent={'space-between'} sx={{...sx}}>
                <Grid container alignItems={'center'} spacing={1}>
                    <Grid>
                        <Typography variant={'caption'} color={'text.secondary'}>
                            {(pagination.total != null && pagination.total > 0) && <>{pagination.total} resultados</>}
                        </Typography>
                    </Grid>
                    {(loading) && <Grid>
                        <CircularProgress size={24}/>
                    </Grid>}
                </Grid>
                <Grid container justifyContent={'flex-end'} alignItems={'center'} spacing={1}>
                    <Tooltip title={'Atualizar & limpar cache'}>
                        <IconButton component={'span'} disabled={setPagination == null || loading == true}
                                    color={'info'}
                                    onClick={() => {
                                        setPagination({...pagination, ignoreCache: true})
                                    }}>
                            <Autorenew sx={{...rollAnimation, animation: loading ? `roll 0.5s infinite` : ''}}/>
                        </IconButton>
                    </Tooltip>
                    <Pagination sx={{py: 0.5}}
                                siblingCount={adjustSizeLevel({sm: 1, lg: 2})}
                                page={pagination.page}
                                count={pagination.pages}
                                onChange={(_e, v) => {
                                    setPagination({...pagination, page: v})
                                }}
                                disabled={pagination.loading || loading}/>
                </Grid>
            </Grid>
            {posicao == 'top' && <Divider/>}
        </Grid>)
}